import React from 'react';
import { Snackbar, Alert, Portal } from '@mui/material';

const AlertComponent = ({ open, message, type, handleClose }) => {
  return (
    <Portal>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleClose} severity={type} sx={{ width: '100%' }} variant="filled">
          {message}
        </Alert>
      </Snackbar>
    </Portal>
  );
};

export default AlertComponent;
